import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useAejOutletContext } from 'pages/GerarAej'
import { useParams } from 'react-router-dom'
import { aej } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirAEJ() {
    const { id } = useParams()
    const { data } = useAejOutletContext()
    const item = data.find(item => item.id === id)

    const { mutateAsync, isLoading } = aej.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!item) return null

    const handleSubmit = () =>
        mutateAsync(item.id as any, {
            onSuccess: () => {
                toast.success('Relatório excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="sm"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'AEJ'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o arquivo AEJ de{' '}
                {dayjs.utc(item.createdAt).format('L')}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
